// src/utils/storage.ts
export const getRememberMeStatus = (): boolean => {
    const rememberMe = localStorage.getItem("rememberMe"); // You can store this value as a string in localStorage
    return rememberMe === "true";
};
  